import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Container } from '../Container';
import { Reveal } from '../Reveal';
import { Section } from '../Section';
import { services } from '../../data/services';
const serviceLayouts = ['lg:mr-16', 'lg:ml-16', 'lg:mr-8', 'lg:ml-24', 'lg:mr-24'];
export function WhatWeDo() {
  return <Section tone="surface" labelledBy="what-we-do-title" className="overflow-hidden" data-id="element-628" data-mp="3hg437pci4cnp">
      <Container data-id="element-629" data-mp="3mexdza0elpk6">
        <div className="grid gap-16 lg:grid-cols-12 lg:gap-0" data-id="element-630" data-mp="3mfgx2u1sijzs">
          <div className="lg:col-span-4 lg:border-r lg:border-hairline lg:pr-12" data-id="element-631" data-mp="3mcl0pa5lc3dg">
            <div className="lg:sticky lg:top-[112px]" data-id="element-632" data-mp="38ewh05n9f29z">
              <Reveal data-id="element-633" data-mp="3cfzvanpnsq93">
                <p className="text-small text-muted" data-id="element-634" data-mp="3cfg9gvww1hps">Capabilities / 05</p>
                <h2 id="what-we-do-title" className="mt-5 max-w-[12ch] text-[40px] leading-[1.03] tracking-[-0.04em] text-ink lg:text-[56px]" data-id="element-635" data-mp="1wzrasrnx6llm">
                  One studio. Five distinct ways in.
                </h2>
                <p className="mt-7 max-w-[31ch] text-body text-muted" data-id="element-636" data-mp="3fbsowc7bw1d2">
                  Each piece stands alone. Most effective projects connect three of them into one
                  considered system.
                </p>
              </Reveal>

              <Reveal delay={0.06} className="mt-12 hidden lg:block" data-id="element-637" data-mp="3p975cbt94q5d">
                <div className="flex items-center gap-3 border-y border-hairline py-5" data-id="element-638" data-mp="73u2ghc012op">
                  <span className="font-serif text-[40px] leading-none tracking-[-0.04em] text-ink" data-id="element-639" data-mp="25k6i4ig9y21">
                    05
                  </span>
                  <p className="max-w-[15ch] text-small leading-5 text-muted" data-id="element-640" data-mp="gtngrq3izvwn">
                    Ways we can make the company feel more like itself.
                  </p>
                </div>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-8 lg:pl-12" data-id="element-641" data-mp="kw1zma772vnx">
            <ol className="border-t border-hairline" data-id="element-642" data-mp="kxd2m7stfzdz">
              {services.map((service, index) => <Reveal as="li" key={service.index} delay={index * 0.06} className={serviceLayouts[index]} data-id="element-643" data-mp="3epl1k7znf320" data-mpi={index}>
                  <Link to={service.to} className="group relative block border-b border-hairline py-8 focus-visible:outline-none lg:py-10" data-id="element-644" data-mp="3jkqona4senro">
                    <div className="absolute inset-y-0 left-0 w-0 bg-canvas transition-[width] duration-300 ease-editorial group-hover:w-full group-focus-visible:w-full" data-id="element-645" data-mp="3sh9f8fpjpzl3" />
                    <div className="relative grid gap-5 px-1 sm:grid-cols-[72px_minmax(0,1fr)_auto] sm:items-start sm:gap-6" data-id="element-646" data-mp="66ne4o0gwhql">
                      <span className="font-serif text-[36px] leading-none tracking-[-0.04em] text-muted transition-colors duration-200 ease-out group-hover:text-accent group-focus-visible:text-accent lg:text-[48px]" data-id="element-647" data-mp="b4x4mlb8yu5v">
                        {service.index}
                      </span>

                      <div className="min-w-0" data-id="element-648" data-mp="2h09mxk377kr2">
                        <h3 className="max-w-[19ch] text-[28px] leading-[1.08] tracking-[-0.035em] text-ink transition-transform duration-300 ease-editorial group-hover:translate-x-3 group-focus-visible:translate-x-3 lg:text-[40px]" data-id="element-649" data-mp="29h0g9ym2u05p">
                          {service.name}
                        </h3>
                        <p className="mt-3 max-w-[36ch] text-small leading-6 text-muted opacity-100 transition-[opacity,transform] duration-200 ease-out sm:opacity-0 sm:translate-y-1 sm:group-hover:translate-y-0 sm:group-hover:opacity-100 sm:group-focus-visible:translate-y-0 sm:group-focus-visible:opacity-100" data-id="element-650" data-mp="1vpv98bgdq5lc">
                          {service.description}
                        </p>
                      </div>

                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-hairline text-muted transition-[transform,border-color,color] duration-200 ease-editorial group-hover:rotate-45 group-hover:border-ink group-hover:text-ink group-focus-visible:rotate-45 group-focus-visible:border-ink group-focus-visible:text-ink" data-id="element-651" data-mp="2eeign0m13723">
                        <ArrowUpRightIcon size={18} aria-hidden="true" data-id="element-652" data-mp="2vnjd9v3lbgf9" />
                      </span>
                    </div>
                  </Link>
                </Reveal>)}
            </ol>
          </div>
        </div>
      </Container>
    </Section>;
}